module.exports = "/images/vendor/flag-icon-css/flags/1x1/mk.svg?2413b10706c9e29c439b0dcf94ec8cfe";